<template>
  <transition name="fade" appear>
    <SmallModal v-if="isModalOpen" @close="closeModal">
      <template v-slot:header>
        <span v-if="step == 'provider'" class="text-secondary font-bold text-lg"
          >Choose a payment method:</span
        >
        <span v-if="step == 'address'" class="text-secondary font-bold text-lg"
          >Update your address:</span
        >
      </template>
      <template v-slot:content>
        <div v-if="isLoading" class="flex items-center justify-center">
          <div class="relative w-12 h-24 mt-4"><SpinLoader /></div>
        </div>
        <div v-if="!isLoading && step == 'provider' && !displayOptions">
          <div
            v-for="provider in providers"
            :key="provider.id"
            class="block my-2 group cursor-pointer"
            @click="selectProvider(provider.id)"
          >
            <div
              class="
                flex
                items-center
                space-x-4
                border
                py-4
                transition-default
                px-4
                rounded-lg
              "
              :class="[
                selectedProvider == provider.id
                  ? 'border-accent'
                  : 'group-hover:bg-primary-variation border-primary-variation',
              ]"
            >
              <div
                class="
                  rounded-full
                  border
                  w-6
                  h-6
                  shadow-md
                  flex
                  items-center
                  justify-center
                  transition-default
                "
                :class="[
                  selectedProvider == provider.id
                    ? 'border-accent'
                    : 'border-secondary-variation',
                ]"
              >
                <transition name="bounce" appear>
                  <div
                    v-if="selectedProvider == provider.id"
                    class="rounded-full bg-accent w-3 h-3"
                  ></div>
                </transition>
              </div>
              <span class="text-secondary font-semibold">{{
                provider.name
              }}</span>
            </div>
          </div>
        </div>
        <div v-if="!isLoading && step == 'provider' && displayOptions">
          <div
            v-for="option in options"
            :key="option.value"
            class="block my-2 group cursor-pointer"
            @click="selectOption(option.value)"
          >
            <div
              class="
                flex
                items-center
                space-x-4
                border
                py-4
                transition-default
                px-4
                rounded-lg
              "
              :class="[
                selectedOption == option.value
                  ? 'border-accent'
                  : 'group-hover:bg-primary-variation border-primary-variation',
              ]"
            >
              <div
                class="
                  rounded-full
                  border
                  w-6
                  h-6
                  shadow-md
                  flex
                  items-center
                  justify-center
                  transition-default
                "
                :class="[
                  selectedOption == option.value
                    ? 'border-accent'
                    : 'border-secondary-variation',
                ]"
              >
                <transition name="bounce" appear>
                  <div
                    v-if="selectedOption == option.value"
                    class="rounded-full bg-accent w-3 h-3"
                  ></div>
                </transition>
              </div>
              <span class="text-secondary font-semibold">{{
                option.name
              }}</span>
            </div>
          </div>
        </div>
        <div v-if="!isLoading && step == 'address'">
          <div class="grid grid-cols-1 gap-2">
            <div>
              <label class="text-secondary font-semibold">{{
                $t("userprofilepage.user_settings.street")
              }}</label>
              <TextInput
                v-model="street"
                class="mt-2"
                :placeholder="$t('userprofilepage.user_settings.street')"
                :error="errors && errors.street ? errors.street[0] : null"
              />
            </div>
            <div>
              <label class="text-secondary font-semibold">{{
                $t("userprofilepage.user_settings.city")
              }}</label>
              <TextInput
                v-model="city"
                class="mt-2"
                :placeholder="$t('userprofilepage.user_settings.city')"
                :error="errors && errors.city ? errors.city[0] : null"
              />
            </div>
            <div>
              <label class="text-secondary font-semibold">{{
                $t("userprofilepage.user_settings.country")
              }}</label>
              <SelectInput
                v-model="country"
                :options="countries"
                searchable
                class="mt-2"
                :error="errors && errors.country ? errors.country[0] : null"
              />
            </div>
            <div>
              <label class="text-secondary font-semibold">{{
                $t("userprofilepage.user_settings.state")
              }}</label>
              <SelectInput
                v-model="state"
                :options="states"
                searchable
                class="mt-2"
                :error="errors && errors.state ? errors.state[0] : null"
              />
            </div>
            <div>
              <label class="text-secondary font-semibold">{{
                $t("userprofilepage.user_settings.postal_code")
              }}</label>
              <TextInput
                v-model="postal_code"
                class="mt-2"
                :placeholder="$t('userprofilepage.user_settings.postal_code')"
                :error="
                  errors && errors.postal_code ? errors.postal_code[0] : null
                "
              />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button
          v-if="!isLoading && step == 'provider'"
          @click="handlePayment"
          class="
            bg-accent
            px-4
            py-2
            font-bold
            text-secondary
            rounded-lg
            transition-default
            flex
            items-center
            hover:bg-secondary hover:text-black
          "
        >
          <div v-if="isLoadingPayment" class="relative w-6 mr-3">
            <SpinLoaderSmall class="spinner-payment" />
          </div>

          <CartIcon class="h-6 w-6 mr-1" /> Buy Now
        </button>
        <button
          v-if="!isLoading && step == 'address'"
          @click="updateAddress"
          class="
            bg-accent
            px-4
            py-2
            font-bold
            text-secondary
            rounded-lg
            transition-default
            flex
            items-center
            hover:bg-secondary hover:text-black
          "
        >
          <div v-if="isLoadingAddress" class="relative w-6 mr-3">
            <SpinLoaderSmall class="spinner-payment" />
          </div>
          Update Address
        </button>
      </template>
    </SmallModal>
  </transition>
</template>

<script>
import SmallModal from "@/components/UI/Modal/SmallModal.vue";
import SpinLoader from "@/components/UI/Loader/SpinLoader.vue";
import SpinLoaderSmall from "@/components/UI/Loader/SpinLoaderSmall.vue";
import CartIcon from "@/components/icons/CartIcon";
import TextInput from "@/components/UI/Inputs/TextInput.vue";
import SelectInput from "@/components/UI/Inputs/SelectInput.vue";
import axios from "axios";
export default {
  name: "VideoStars",
  data() {
    return {
      providers: null,
      selectedProvider: null,
      step: "provider",
      isLoading: true,
      isLoadingPayment: false,
      isLoadingAddress: false,
      countries: [],
      country: null,
      states: [],
      state: null,
      street: null,
      city: null,
      postal_code: null,
      subscription: null,
      errors: null,
      displayOptions: false,
      options: null,
      selectedOption: null,
    };
  },
  components: {
    SmallModal,
    SpinLoader,
    SpinLoaderSmall,
    CartIcon,
    TextInput,
    SelectInput,
  },
  props: {
    isModalOpen: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    item: {
      type: Number,
      required: true,
    },
  },
  computed: {
    authUser() {
      return this.$store.getters["user/authUser"];
    },
  },
  watch: {
    isModalOpen(newValue) {
      if (newValue) {
        this.step = "provider";
        this.getPaymentProviders();
      }
    },
    step(newValue) {
      if (newValue == "address") {
        this.getCountries();
      }
    },
    selectedProvider(newValue) {
      const provider = this.providers.find(
        (provider) => provider.id == newValue
      );
      if (provider.return_type == "options") {
        this.options = provider.return_options;
        this.displayOptions = true;
        this.selectedOption = provider.return_options[0].value;
      }
    },
    country() {
      this.getStates();
    },
  },
  methods: {
    updateAddress() {
      if (!this.authUser) {
        return;
      }
      this.isLoadingAddress = true;
      this.errors = null;
      axios
        .put(`/user/${this.authUser.id}`, {
          street: this.street,
          city: this.city,
          country: this.country,
          state: this.state,
          postal_code: this.postal_code,
        })
        .then(() => {
          this.step = "provider";
          this.isLoadingAddress = false;
        })
        .catch((error) => {
          this.isLoadingAddress = false;
          this.errors = error.response.data.errors;
        });
    },
    getCountries() {
      axios
        .get("/countries")
        .then((response) => {
          this.countries = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getStates() {
      this.state = null;
      axios
        .get(`/countries/${this.country}/states`)
        .then((response) => {
          this.states = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handlePayment() {
      this.isLoadingPayment = true;
      const provider = this.providers.find(
        (provider) => provider.id == this.selectedProvider
      );
      let args = {};
      if (provider.return_type == "options") {
        args = {
          type: this.type,
          item: this.item,
          payment_provider: this.selectedProvider,
          option: this.selectedOption,
        };
      }
      if (provider.return_type == "redirect") {
        args = {
          type: this.type,
          item: this.item,
          payment_provider: this.selectedProvider,
        };
      }
      axios
        .post(`/orders`, args)
        .then((response) => {
          window.location.href = response.data.url;
        })
        .catch((error) => {
          this.isLoadingPayment = false;
          let action = error.response.data.action;
          if (action && action == "set_address") {
            this.step = "address";
          }
        });
    },
    getPaymentProviders() {
      this.isLoading = true;
      axios
        .get(`/payments/providers`)
        .then((response) => {
          this.isLoading = false;
          this.providers = response.data.data;
          if (this.providers.length == 0) {
            this.closeModal();
          } else {
            this.selectedProvider = this.providers[0].id;
          }
        })
        .catch((error) => {
          this.closeModal();
          console.log(error);
        });
    },
    selectProvider(id) {
      this.selectedProvider = id;
    },
    selectOption(value) {
      this.selectedOption = value;
    },
    closeModal() {
      this.$emit("modalClose");
    },
  },
};
</script>

<style>
.spinner-payment .path {
  stroke: rgba(0, 0, 0, 1);
}
</style>